import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('level_funded_benefits_set', '/level_funded_benefits_sets', 'benefits_set')
const reducer = generator.generate()

export default reducer
